<div class="form-version-selector">
  <div *ngIf="loading" class="form-version-loading-mask">
    <i class="fas fa-spin fa-spinner"></i>
  </div>

  <ng-container *ngIf="hasForm; else selectFormInfo">
    <div class="form-check form-version-latest">
      <input
        id="useAlwaysLatestFormVersion"
        type="checkbox"
        class="form-check-input"
        [ngModel]="useAlwaysLatest"
        [disabled]="isDisabled || loading || versions.length === 0"
        (ngModelChange)="onUseAlwaysLatestChange($event)"
        (blur)="onTouched()" />
      <label class="form-check-label" for="useAlwaysLatestFormVersion">
        {{ 'Dashboard::QualityReport:UseLatestVersion' | abpLocalization }}
        <span *ngIf="latestVersion">({{ 'v' + latestVersion.version }})</span>
      </label>
    </div>

    <div class="row m-0 form-version-toolbar">
      <div class="col p-0">
        <ng-select
          [items]="versions"
          [ngModel]="selectedVersion"
          [disabled]="dropdownDisabled"
          [clearable]="false"
          [searchable]="false"
          dropdownPanelClass="fill-width form-version-selector-dropdown"
          bindLabel="version"
          (open)="onDropdownOpen()"
          (change)="onVersionChange($event)"
          (blur)="onTouched()">
          <ng-template ng-label-tmp let-item="item">
            {{ item.version }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.version }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-auto ps-2 form-version-clear-selection" *ngIf="hasSelection">
        <button
          class="ca-btn ca-btn-link ca-btn-link-sm p-0"
          type="button"
          (click)="onClearSelectionClick($event)">
          {{ '::Clear' | abpLocalization }}
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #selectFormInfo>
    <div class="form-version-info">
      <i class="fa-regular fa-circle-info"></i>
      <span>Please select a form.</span>
    </div>
  </ng-template>
</div>
